import React from 'react';
import styled from 'styled-components';
import _ from 'lodash';
import moment from 'moment';
import { ResponsiveLine } from '@nivo/line';
import { _font } from 'styles/_variables';
import { color } from 'styles/utils';
import { useImmer } from 'use-immer';
import { PieChart } from 'react-minimal-pie-chart';

export default function DonutChart({
  width = 250,
  bgColor = '',
  noDataVisible = true,
  noDataHeight = 0,
  data = [],
  legendsData = [],
  children,
  lineWidth = 35,
  rounded = false,
  startAngle = -90,
  labelVisible = false,
  paddingAngle = 0,
  labelPosition = 0,
  radius = 50,
  segmentsShift = 0,
}) {
  const containerStyle = {
    width,
    height: width,
  };

  const noDataStyle = {
    width,
    height: noDataHeight || width,
  };

  const defaultLabelStyle = {
    fontSize: '8px',
    fontFamily: 'sans-serif',
  };

  return (
    <Styled.PieChart style={containerStyle} data-component-name="DonutChart" bgColor={bgColor}>
      {!data.length && noDataVisible && (
        <div className="chart__no_data" style={noDataStyle}>
          No data.
        </div>
      )}
      <div className="chart__box">
        {children}
        {/* <PieChart
          data={data}
          lineWidth={lineWidth}
          animate
          startAngle={startAngle}
          rounded={rounded}
          // lengthAngle={180}
          // label={({ dataEntry }) => dataEntry.value}
          // label={({ dataEntry }) => Math.round(dataEntry.percentage) + '%'}
          // labelStyle={index => ({
          //   ...defaultLabelStyle,
          //   // fill: '#000',
          //   fill: data[index].color,
          // })}
          // labelPosition={80}
          // radius={42}
        /> */}
        <PieChart
          data={data}
          lineWidth={lineWidth}
          animate
          startAngle={startAngle}
          rounded={rounded}
          // lengthAngle={180}
          label={
            labelVisible ? ({ dataEntry }) => (dataEntry.value > 0 ? dataEntry.value : null) : null
          }
          // label={({ dataEntry }) => Math.round(dataEntry.percentage) + '%'}
          labelStyle={index => ({
            ...defaultLabelStyle,
            // fill: '#000',
            // fill: data[index].color,
            fill: '#fff',
          })}
          labelPosition={labelPosition}
          paddingAngle={paddingAngle}
          // segmentsStyle={{ transition: 'stroke .2s', cursor: 'pointer' }}
          segmentsShift={segmentsShift}
          radius={radius - segmentsShift}
        >
          <defs>
            <linearGradient id="gradientBlue">
              <stop offset="0%" stopColor="#00A6E2" />
              <stop offset="100%" stopColor="#087BEE" />
            </linearGradient>
          </defs>
        </PieChart>
      </div>
    </Styled.PieChart>
  );
}

const Styled = {
  PieChart: styled.div`
    position: relative;
    margin: 0 auto;
    background-color: ${({ bgColor }) => (bgColor ? bgColor : '#fff')};
    border-radius: 50%;
    & {
      .chart__box {
        position: relative;
      }
      .chart__no_data {
        display: flex;
        align-items: center;
        justify-content: center;
        text-align: center;
        height: 350px;
        font-size: 16px;
        line-height: 1.3;
        color: #7c7c7c;
      }
    }
  `,
};
